/** Resolve untrusted login destinations without changing origins or schemes. */
export function safeDestination(next: string | null, origin: string): string {
  if (!next || /[\\\u0000-\u001f\u007f]/.test(next)) return "/dashboard";
  try {
    const destination = new URL(next, origin);
    if (destination.origin !== origin || !["http:", "https:"].includes(destination.protocol)
      || destination.username || destination.password) return "/dashboard";
    return destination.pathname + destination.search + destination.hash;
  } catch { return "/dashboard"; }
}
